// generated from 1_456_502 samples

import { z } from "zod";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const customAttributesFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("custom_attributes_filter"),
  // undefined: 1_456_420 (99.99%), defined 82 (0.01%)
  blocklisted: z.literal(true).optional(),
  // format integer: 1_456_502 (100.00%)
  comparison_key: z.string(),
  display_name: z.string(),
  // undefined: 622_762 (42.76%), defined 833_740 (57.24%)
  raw_value: z
    .union([
      // boolean samples: 110_930 (13.31%)
      // true 90_066 (81.19%), false 20_864 (18.81%)
      z.boolean(),
      // number samples: 156_034 (18.71%)
      // integer: 153_268 (98.23%)
      // avg: 29594654042595.07, min: -999999, max: 4611686018427388000
      z.number(),
      // string samples: 523_228 (62.76%)
      z.string(),
      // array samples: 43_548 (5.22%)
      z.array(z.union([z.string(), z.number()])),
    ])
    .optional(),
  value: z.union([
    // null samples: 5 (0.00%)
    z.null(),
    // boolean samples: 171_294 (11.76%)
    // true 142_214 (83.02%), false 29_080 (16.98%)
    z.boolean(),
    // number samples: 275_887 (18.94%)
    // integer: 272_221 (98.67%)
    // avg: 16738445942218.40, min: -2000000, max: 4611686018427388000
    z.number(),
    // string samples: 941_265 (64.63%)
    z.string(),
    // array samples: 68_051 (4.67%)
    z.array(z.union([z.string(), z.number()])),
  ]),
  varies_by_app_group: z.literal(true),
});
